import { render, staticRenderFns } from "./ActiveIncidencesList.vue?vue&type=template&id=57b9ba2b&"
import script from "./ActiveIncidencesList.vue?vue&type=script&lang=js&"
export * from "./ActiveIncidencesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports